// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"194":"error","356":"privacy","724":"brand","952":"promotion"}[chunkId] + "-legacy." + {"194":"0518e325","356":"700c5ad4","724":"7edd7721","952":"19d9d3ce"}[chunkId] + ".js";
};